import { FreeGameButtonControllerBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist"

export class FreeGameButtonControllerGame extends FreeGameButtonControllerBehavior {
    /**
     * handle turbo and autoplay button 
     */
    protected handleButtons(): void {
        !SlotConstantsBehavior.SHOW_TURBO_BUTTONS && this.hideTurboButtons();
        !SlotConstantsBehavior.SHOW_AUTOPLAY_BUTTONS && this.hideAutoplayButtons();
        super.handleButtons();
    }
}